import { Store } from "@mail/core/common/store_service";

import { patch } from "@web/core/utils/patch";

/** @type {import("models").Store} */
const StorePatch = {
    setup() {
        super.setup(...arguments);
        this.hasGifPickerFeature = false;
    },
};
patch(Store.prototype, StorePatch);
